import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';

import SignInScreen from './SignInScreen';
import {
    lookupUser as lookupUserAction,
    logInUser as logInUserAction,
    signUpUser as signUpUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    trackGetStartedClick as trackGetStartedClickAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    trackLoginInsteadClick as trackLoginInsteadAction,
    sendEmailLinkAccount as sendEmailLinkAccountAction,
} from '../../actions/auth';
import {
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialSignUpUser as socialSignUpUserAction,
} from '../../actions/social';

import {
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
    trackTermsOfServiceClicked as trackTermsOfServiceClickedAction,
    trackCommunityGuidelinesClicked as trackCommunityGuidelinesClickedAction,
    trackPrivacyPolicyClicked as trackPrivacyPolicyClickedAction,
} from '../../actions/gaTracking';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    email: authentication.email,
    socialData: authentication.socialData,
    socialAuthenticationData: authentication.socialAuthenticationData,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    shouldRenderAuthNotification: !isEmpty(
        authentication.authNotificationOptions,
    ),
    authTypeSetting: authentication.authTypeSetting,
    stld: authentication.stld,
    shouldIncludeEmailConfirmation:
        authentication.shouldIncludeEmailConfirmation,
    showCreatorEncouragement: authentication.showCreatorEncouragement,
    disableRecaptcha3: authentication.disableRecaptcha3,
    referrer: authentication.referrer,
    launchSendLinkAccountEmail:
        authentication.featureFlags.launchSendLinkAccountEmail,
});

const _mapDispatchToProps = {
    onLookupUser: lookupUserAction,
    onLogInUser: logInUserAction,
    onSignUpUser: signUpUserAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialSignUpUser: socialSignUpUserAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    onLinkedAccountsCreatePassword: sendResetPasswordEmailAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onGetStartedClick: trackGetStartedClickAction,
    onTermsOfServiceClick: trackTermsOfServiceClickedAction,
    onComunityGuidelinesClick: trackCommunityGuidelinesClickedAction,
    onPrivacyPolicyClick: trackPrivacyPolicyClickedAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
    handleSendMailLinkAccount: sendEmailLinkAccountAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignInScreen),
);
